<div class="rpt">
  <div class="rpt-vehicle" *ngIf="showVehicle">
    <div class="rpt-vehicle-label">{{ '@issueReportVehicle' | translate }}</div>
    <div class="rpt-vehicle-value">
      <span class="rpt-vehicle-name">{{ assetName }}</span>
      <span class="rpt-vehicle-vin" *ngIf="assetVin">{{ assetVin }}</span>
    </div>
  </div>

  <mat-form-field class="rpt-field" subscriptSizing="dynamic">
    <mat-label>{{ '@issueReportSummary' | translate }}</mat-label>
    <input matInput [(ngModel)]="summary" maxlength="200" data-e2e="report-issue-summary"
           [placeholder]="'@issueReportSummaryPlaceholder' | translate">
    <mat-hint>{{ '@issueReportSummaryHintProblem' | translate }}</mat-hint>
  </mat-form-field>

  <mat-form-field class="rpt-field" subscriptSizing="dynamic">
    <mat-label>{{ '@issueReportDetails' | translate }}</mat-label>
    <textarea matInput rows="4" [(ngModel)]="details" [maxlength]="maxDescription" data-e2e="report-issue-details"
              [placeholder]="'@issueReportDetailsPlaceholder' | translate"></textarea>
    <mat-hint>{{ '@issueReportCharsLeft' | translate: { count: detailsRemaining } }}</mat-hint>
  </mat-form-field>

  <mat-form-field class="rpt-field" subscriptSizing="dynamic">
    <mat-label>{{ '@issueReportProblem' | translate }}</mat-label>
    <input matInput [matAutocomplete]="systemAuto" data-e2e="report-issue-system"
           [ngModel]="systemModel" (ngModelChange)="onSystemInput($event)"
           [placeholder]="'@issueReportProblemPlaceholder' | translate">
    <mat-autocomplete #systemAuto="matAutocomplete" [displayWith]="displaySystem"
                      (optionSelected)="onSystemSelected($event.option.value)">
      <mat-optgroup *ngFor="let group of systemGroups" [label]="group.category">
        <mat-option *ngFor="let entry of group.entries" [value]="entry">{{ entry.displayName }}</mat-option>
      </mat-optgroup>
    </mat-autocomplete>
    <mat-hint>{{ '@issueReportProblemHint' | translate }}</mat-hint>
  </mat-form-field>

  <div class="rpt-inline-note" *ngIf="catalogLoading">{{ '@issueReportProblemLoading' | translate }}</div>
  <div class="rpt-inline-error" *ngIf="catalogError">{{ '@issueReportProblemLoadError' | translate }}</div>

  <div class="rpt-merge" *ngIf="mergeTarget">
    <mat-icon class="rpt-merge-icon">merge_type</mat-icon>
    <div class="rpt-merge-body">
      <div class="rpt-merge-title">{{ '@issueReportMergeTitle' | translate: { name: mergeTarget.displayName } }}</div>
      <div class="rpt-merge-sub">{{ '@issueReportMergeBody' | translate }}</div>
    </div>
  </div>

  <div class="rpt-block">
    <div class="rpt-block-label">{{ '@issueReportSeverity' | translate }}</div>
    <div class="rpt-severity" role="radiogroup"
         [attr.aria-label]="'@issueReportSeverity' | translate">
      <button type="button" class="rpt-sev" *ngFor="let band of severityBands"
              role="radio"
              [ngClass]="band.css"
              [class.picked]="severity === band.value"
              [attr.aria-checked]="severity === band.value"
              (click)="severity = band.value">
        {{ band.labelKey | translate }}
      </button>
    </div>
  </div>

  <div class="rpt-block">
    <button type="button" class="rpt-faults-toggle" data-e2e="report-issue-faults-toggle" (click)="toggleFaults()">
      <mat-icon class="rpt-caret" [class.open]="faultsOpen">chevron_right</mat-icon>
      <span>{{ '@issueReportFaults' | translate }}</span>
      <span class="rpt-faults-count" *ngIf="selectedFaultCount">
        {{ '@issueReportFaultsSelected' | translate: { count: selectedFaultCount } }}
      </span>
    </button>

    <div class="rpt-faults-body" *ngIf="faultsOpen">
      <div class="rpt-inline-note" *ngIf="faultsLoading">{{ '@issueReportFaultsLoading' | translate }}</div>
      <div class="rpt-inline-note" *ngIf="!faultsLoading && !faultOptions.length">
        {{ '@issueReportFaultsNone' | translate }}
      </div>
      <div class="rpt-fault-row" *ngFor="let option of faultOptions">
        <mat-checkbox [checked]="option.selected" (change)="toggleFault(option)"
                      [disabled]="!option.selected && selectedFaultCount >= maxFaults">
          <span class="rpt-fault-label">{{ option.label }}</span>
          <span class="rpt-fault-detail">{{ option.detail }}</span>
        </mat-checkbox>
      </div>
      <div class="rpt-inline-note" *ngIf="selectedFaultCount >= maxFaults">
        {{ '@issueReportFaultsCapped' | translate: { max: maxFaults } }}
      </div>
    </div>
  </div>

  <div class="rpt-errors" #errorList *ngIf="errors.length">
    <div class="rpt-error" *ngFor="let error of errors">{{ error }}</div>
  </div>

  <div class="rpt-actions" *ngIf="showActions">
    <button mat-stroked-button data-e2e="report-issue-cancel" [disabled]="submitting" (click)="cancel()">{{ '@cancel' | translate }}</button>
    <button mat-flat-button color="primary" data-e2e="report-issue-submit"
            [disabled]="submitting" (click)="submit()">
      {{ submitLabelKey | translate }}
    </button>
  </div>
</div>
